import { FC, ReactNode } from 'react'

interface ShipmentCalculatedValueProps {
    isActual?: boolean
    children: ReactNode
}

const ShipmentCalculatedValue: FC<ShipmentCalculatedValueProps> = ({ children }) => {
    return <>{children}</>
}

export default ShipmentCalculatedValue
